module.exports = __webpack_public_path__ + "img/ic_20_ignore.65e4d95f.svg";